import * as Sentry from '@sentry/react';

const dsn = (process.env.REACT_APP_SENTRY_DSN_SHOP || '').trim();

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Do not list API hosts here: sentry-trace/baggage on cross-origin fetches require CORS
    // Allow-Headers on the API. Propagate only for local dev (same machine API).
    tracePropagationTargets: [/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//],
    sendDefaultPii: true,
    enableLogs: true,
  });
}
